module.exports = __webpack_public_path__ + "img/chess-knight.e6a4cb39.svg";